/** 不包裹 LayoutDefault 的独立顶层路由 */
const STANDALONE_EXACT_PATHS = new Set(['/jieSeriesDashboard']);

export function isStandalonePath(pathname: string) {
  const normalized = (pathname || '/').replace(/\/+$/, '') || '/';
  if (normalized.includes('/updateLog/')) return true;
  return STANDALONE_EXACT_PATHS.has(normalized);
}
